<!-- eslint-disable -->
<script setup>
import commonSvgs from '@/assets/svgs/commonSvgs.json'
import { useCustomerStore } from '@/stores/customer';
import { computed, onMounted, ref } from 'vue';
import { closeModal, confirmModal } from '@kolirt/vue-modal'
import { useNotificationStore } from '@/stores/notifications';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { useCurrenciesStore } from '@/stores/currencies';

const router = useRouter();
const notificationStore = useNotificationStore()
const customerStore = useCustomerStore();
const currenciesStore = useCurrenciesStore();
const { t } = useI18n();
const svgs_data = commonSvgs;

const props = defineProps({
	title: {},
	body: {},
	notification: {}
})

const closeModalOnClickOutside = (event) => {
	event.stopPropagation();
	// Check if the click occurred outside the modal
	if (!event.target.closest('.modal-content')) {
		closeModal();
		// Call the modalClosedCallback passed from the parent
		customerStore.customer_notification_id = null;
	}

	if (props.notification.read_at == null) {
		notificationStore.updateCustomerNotification(props.notification).then(() => {
			notificationStore.fetchCustomerNotifications({page: 1});
			notificationStore.fetchCustomerUnreadNotifications({page: 1})
		});
	}
};

const goToUrl = () => {
	closeModal();

	if (props.notification.read_at == null) {
		notificationStore.updateCustomerNotification(props.notification).then(() => {
			goToPage(props.notification.button_link_url);
		});
	} else {
		goToPage(props.notification.button_link_url);
	}
}

const goToPage = ((url) => {
	if (url.startsWith(process.env.VUE_APP_URL)) {
		const sliced = url.slice(process.env.VUE_APP_URL.length);
		router.push({'path': sliced});
		return;
	}

	window.location.href = url;
});

const title = computed(() => {
	if (props.title == 'deposit_bonus') return t('popup_notification.deposit_bonus');
	return props.title || t('general.notification');
});

const body = computed(() => {
	if (props.body.includes('freebet_from_deposit_received')) {
		let parts = props.body.split(', ');
		let amount = parts[1];
		return t('popup_notification.freebet_from_deposit_received', { amount: currenciesStore.format_currency(amount, customerStore.customer.currency.code) });
	} else if (props.body.includes('freespins_from_deposit_received')) {
		let parts = props.body.split(', ');
		let amount = parts[1];
		return t('popup_notification.freespins_from_deposit_received', { amount: amount });
	} else return props.body || '';
});

const notificationButton = computed(() => {
	if (!props.notification?.button_name) return t('general.close');
	if (props.notification?.button_name == 'view_deposit_bonus') return t('popup_notification.view_bonus');
	return props.notification?.button_name || t('general.close');
});

</script>
<template>

	<div class="modal-outer verify-email-popup" ref="modal" @click="closeModalOnClickOutside">
		<!-- overlay -->
		<div class="overlay"></div>
		<!-- modal -->
		<div class="modal">
			<button class="close" @click="closeModalOnClickOutside"  v-html="svgs_data.popup_cross"></button>

			<template v-if="props">
				<div class="modal-header">
					<h3>{{ title }}</h3>
				</div>
				<div class="password-reset-main">
					<div class="popup-message">
						<p v-html="body"></p>
					</div>
					<template v-if="props.notification?.button_link_url">
						<button class="btn btn-secondary" type="button" @click="goToUrl()">
							{{ notificationButton }}
						</button>
					</template>
					<template v-else>
						<button class="btn btn-secondary" type="button" @click="closeModalOnClickOutside">
							{{ notificationButton }}
						</button>
					</template>
				</div>
			</template>
		</div>

	</div>
</template>
<style scoped>
	.popup-message {
		overflow-wrap: break-word;
		word-wrap: break-word;
	}
</style>